import { MdCheck } from 'react-icons/md';
import { useEffect } from 'react';
import { ReportingControllerBaseConfig } from '../../../../../base';
import { TextElementController } from './textElementInterface';
import { TextElementViewProps } from './textElementProps';

export function createTextElementController(
    config: ReportingControllerBaseConfig
): TextElementController {
    return {
        useProps(props): TextElementViewProps {
            return {
                containerRef: props.containerRef,
                isEmpty: props.field.value === null,
                edit: {
                    value: props.isEditing,
                    button: {
                        onClick() {
                            props.onEdit();
                        },
                    },
                },
                format: props.format,
                submit: {
                    label: 'Save',
                    Icon: MdCheck,
                    button: {
                        isDisabled: !props.field.isDirty,
                        onClick(event) {
                            props.onSubmit(props.field.value);
                            event.preventDefault();
                            event.stopPropagation();
                        },
                        // NOTE Need to prevent mouse down event event from trigger blur handler
                        onMouseDown(event) {
                            event.preventDefault();
                        },
                    },
                },
                label: props.field.value ?? 'Empty',
                input: {
                    onKeyDown(event) {
                        if (event.key === 'Enter' && props.isEditing) {
                            props.onSubmit(props.field.value);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        if (event.key === 'Escape' && props.isEditing) {
                            props.onCancel();
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    },
                    value: props.field.value ?? '',
                    onChange(event) {
                        if (event.currentTarget.value.trim() === '') {
                            props.field.onChange(null);
                            return;
                        }
                        props.field.onChange(event.currentTarget.value);
                    },
                    onBlur(event) {
                        props.onBlur();
                    },
                },
            };
        },
    };
}
